import React from 'react'
import firebase from 'firebase'
import {Textfield, ProgressBar} from 'react-mdl'
import {writeUserData} from 'firebase-main'

import './profile.css'


export default class Profile extends React.PureComponent {

  constructor(props) {
    super(props)
    firebase.database().ref('/users/' + firebase.auth().currentUser.uid)
      .once(  'value',  snapshot => this.setState({ ...snapshot.val() })  )
  }

  onTelegramLinkClick = () => {
    window.open(`https://t.me/${this.tglink.inputRef.value}`, '_blank')
  }

  changeTelegram = e => {
    this.setState({
      telegram: e.target.value
    }, this.storeToFirebase)
  }

  changeHangout = e => {
    this.setState({
      hangout: e.target.value
    }, this.storeToFirebase)
  }

  changeCustom = e => {
    this.setState({
      custom: e.target.value
    }, this.storeToFirebase)
  }

  storeToFirebase = () => {
    writeUserData(this.state)
  }

  render() {
    if (!this.state) return <ProgressBar className='pageLoader' title='loading from firebase' indeterminate/>

    const {telegram, hangout, custom} = this.state
    const warning = !((telegram && telegram.length) || (hangout && hangout.length) || (custom && custom.length))

    return (
      <div className="posts-container mdl-cell mdl-cell--12-col mdl-grid">


        <div className="post full post--KvwRr5wMp4e4nMQsgc0 mdl-cell mdl-cell--12-col mdl-cell--6-col-tablet mdl-cell--4-col-desktop mdl-grid mdl-grid--no-spacing">
          <div className="mdl-card full mdl-shadow--2dp">
            <div className="mdl-card__title mdl-color--light-blue-600 mdl-color-text--white">
              <h4 className="mdl-card__title-text">Profile details</h4>
            </div>
            <div className='column'>

              { warning && <div className='row'>
                <div className='warning'>
                  <p>At least one contact option must be entered.</p>
                </div>
              </div> }

              <div className='row'>
                <label htmlFor='textField1' className='option'>
                  Telegram username
                </label>
                <div className='value'>
                  <span className='link' onClick={this.onTelegramLinkClick}>https://t.me/</span>
                  <Textfield
                    pattern='[^@]*'
                    id='textField1'
                    defaultValue={telegram}
                    onChange={this.changeTelegram}
                    label="username"
                    error="remove @ sign"
                    ref={r => this.tglink = r}
                  />
                </div>
              </div>

              <div className='row'>
                <label htmlFor='textField2' className='option'>
                  Hangouts email
                </label>
                <div className='value'>
                  <Textfield
                    type='email'
                    id='textField2'
                    defaultValue={hangout}
                    onChange={this.changeHangout}
                    label="example@gmail.com"
                  />
                </div>
              </div>

              <div className='row'>
                <label htmlFor='textField3' className='option'>
                  Custom
                </label>
                <div className='value'>
                  <Textfield
                    rows={3}
                    id='textField3'
                    defaultValue={custom}
                    onChange={this.changeCustom}
                    label="sms: +0 123 456 789"
                  />
                </div>
              </div>

            </div>
          </div>
        </div>


      </div>
    )
  }
}






// WEBPACK FOOTER //
// ./src/client/pages/Profile.jsx